





































































































































































































import { default as Component } from 'vue-class-component';

import vSelect from 'vue-select';

import DeliveryWidget from '@/components/widgets/DeliveryWidget.vue';
import DatePicker from '@/components/vuejs-datepicker/src/components/Datepicker.vue';
import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Api from '@/interfaces/Api';
import Tracking from '@/interfaces/Tracking';
import { Watch } from 'vue-property-decorator';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  props: {
    availableProviders: Array,
    isMobile: Boolean
  },
  components: {
    'v-select': vSelect,
    'date-picker': DatePicker,
    'messages-block': MessagesBlock
  }
})
export default class HsgDeliveryWidget extends DeliveryWidget {
  public authorize_to_terminate = false;
  public signDate: string | null = null;
  public signatureName: string | null = null;

  @Watch('sessionMappedDelivery')
  public onSessionMappedDeliveryChange(): void {
    if (this.sessionState.genericStorage.signatureDate && this.sessionState.genericStorage.signatureName) {
      this.authorize_to_terminate = true;
    }
    this.signDate = this.sessionState.genericStorage.signatureDate;
    this.signatureName = this.sessionState.genericStorage.signatureName;
  }

  get isErrorCustomerSpecification(): boolean {
    return typeof this.errorHsgCustomerSpecification !== 'undefined' && this.errorHsgCustomerSpecification !== null;
  }
  get isErrorAuthorizeToTerminate(): boolean {
    return typeof this.errorHsgAuthorizeToTerminate !== 'undefined' && this.errorHsgAuthorizeToTerminate !== null;
  }
  get isErrorSignatureName(): boolean {
    return typeof this.errorHsgSignatureName !== 'undefined' && this.errorHsgSignatureName !== null;
  }
  get isErrorSignatureDate(): boolean {
    return typeof this.errorHsgSignatureDate !== 'undefined' && this.errorHsgSignatureDate !== null;
  }
  get errorHsgCustomerSpecification(): { key: string; message: string } | null {
    return this.getHsgError('customerSpecification');
  }
  get errorHsgAuthorizeToTerminate(): { key: string; message: string } | null {
    return this.getHsgError('authorizeToTerminate');
  }
  get errorHsgSignatureName(): { key: string; message: string } | null {
    return this.getHsgError('signatureName');
  }
  get errorHsgSignatureDate(): { key: string; message: string } | null {
    return this.getHsgError('signatureDate');
  }
  get notMoving(): boolean {
    return this.deliveryData.customerSpecification && this.deliveryData.customerSpecification.id !== 'relocation_at';
  }
  get isErrorDate(): boolean {
    return typeof this.errorHsgDate !== 'undefined' && this.errorHsgDate !== null;
  }
  get errorHsgDate(): { key: string; message: string } | null {
    if (this.deliveryData.date && this.deliveryData.customerSpecification) {
      switch (this.deliveryData.customerSpecification.id) {
        case 'desired_date':
          return this.getHsgError('desiredDate');
        case 'terminated_in_person':
          return this.getHsgError('terminationDate');
        case 'relocation_at':
          return this.getHsgError('relocationDate');
        case 'basic_supply':
          return this.getHsgError('basicSupplyDate');
      }
    }
    return null;
  }

  get isErrorCounterNumber(): boolean {
    return typeof this.errorHsgCounterNumber !== 'undefined' && this.errorHsgCounterNumber !== null;
  }
  get errorHsgCounterNumber(): { key: string; message: string } | null {
    return this.getHsgError('counterNumber');
  }

  get isErrorMarketLocationIdentifier(): boolean {
    return (
      typeof this.errorHsgMarketLocationIdentifier !== 'undefined' && this.errorHsgMarketLocationIdentifier !== null
    );
  }
  get errorHsgMarketLocationIdentifier(): { key: string; message: string } | null {
    return this.getHsgError('marketLocationIdentifier');
  }

  get isErrorPreviousProviderCodeNumber(): boolean {
    return (
      typeof this.errorHsgPreviousProviderCodeNumber !== 'undefined' && this.errorHsgPreviousProviderCodeNumber !== null
    );
  }
  get errorHsgPreviousProviderCodeNumber(): { key: string; message: string } | null {
    return this.getHsgError('previousProviderCodeNumber');
  }

  public getHsgError(fieldName: string): { key: string; message: string } | null {
    if (!this.errorsBag) {
      return null;
    }
    return typeof this.errorsBag[fieldName] === 'object' ? this.errorsBag[fieldName] : null;
  }

  public saveSignDate(date: string): void {
    if (date) {
      this.signDate = date;
    } else {
      this.signDate = null;
    }
  }

  public validateDate(): boolean {
    this.resetDateErrors();

    if (
      this.deliveryData.customerSpecification &&
      this.deliveryData.customerSpecification.id === 'earliest_possible_date'
    ) {
      this.deliveryData.date = null;
      return true;
    }

    if (
      this.deliveryData.customerSpecification &&
      this.deliveryData.customerSpecification.id !== 'earliest_possible_date' &&
      !this.isDateValid(this.deliveryData.date)
    ) {
      switch (this.deliveryData.customerSpecification.id) {
        case 'desired_date':
          this.setErrorsBag(
            'desiredDate',
            'delivery.widget.delivery.desired.date.error',
            this.$t('delivery.widget.delivery.desired.date.error').toLocaleString()
          );
          break;
        case 'terminated_in_person':
          this.setErrorsBag(
            'terminationDate',
            'delivery.widget.delivery.terminated.in.person.error',
            this.$t('delivery.widget.delivery.terminated.in.person.error').toLocaleString()
          );
          break;
        case 'relocation_at':
          this.setErrorsBag(
            'relocationDate',
            'delivery.widget.delivery.relocation.error',
            this.$t('delivery.widget.delivery.relocation.error').toLocaleString()
          );
          break;
      }
      this.restrictGoNext = true;
      return false;
    }
    return true;
  }

  public deliverySubmit(): Promise<void> | void {
    this.errorsBag = null;

    if (!this.authorize_to_terminate) {
      this.setErrorsBag(
        'authorizeToTerminate',
        'delivery.widget.authorize.to.terminate.error',
        this.$t('delivery.widget.authorize.to.terminate.error').toLocaleString()
      );
    }

    if (!this.signDate) {
      this.setErrorsBag(
        'signatureDate',
        'delivery.widget.signature.date.error',
        this.$t('delivery.widget.signature.date.error').toLocaleString()
      );
    }

    if (!this.signatureName) {
      this.setErrorsBag(
        'signatureName',
        'delivery.widget.signature.name.error',
        this.$t('delivery.widget.signature.name.error').toLocaleString()
      );
    }

    let desiredDate = null;
    let terminationDate = null;
    let relocationDate = null;
    let basicSupplyDate = null;

    if (!this.deliveryData.customerSpecification) {
      this.setErrorsBag(
        'customerSpecification',
        'delivery.widget.delivery.date.error',
        this.$t('delivery.widget.delivery.date.error').toLocaleString()
      );
    }

    switch (this.deliveryData.customerSpecification.id) {
      case 'desired_date':
        desiredDate = this.deliveryData.date;
        break;
      case 'terminated_in_person':
        terminationDate = this.deliveryData.date;
        break;
      case 'relocation_at':
        relocationDate = this.deliveryData.date;
        break;
      case 'basic_supply':
        basicSupplyDate = this.deliveryData.date;
        break;
    }

    if (!this.validateDate()) {
      this.setErrorsForRequired();
      return;
    }

    const previousProviderCodeNumber =
      this.deliveryData.previousProvider && this.deliveryData.previousProvider.codeNumber
        ? this.deliveryData.previousProvider.codeNumber
        : null;
    const counterNumber = this.deliveryData.counterNumber;
    const marketLocationIdentifier = this.deliveryData.marketLocationIdentifier;
    const customerSpecification = this.deliveryData.customerSpecification
      ? this.deliveryData.customerSpecification.id
      : null;

    if (counterNumber === null) {
      this.setErrorsBag(
        'counterNumber',
        'rules.delivery.counterNumber.required',
        this.$t('rules.delivery.counterNumber.required').toLocaleString()
      );
    }

    if (counterNumber !== null && !/\d/.test(counterNumber)) {
      this.setErrorsForRequired();
      this.setErrorsBag(
        'counterNumber',
        'delivery.widget.meter.number.error',
        this.$t('delivery.widget.meter.number.error').toLocaleString()
      );
      return;
    }

    if (this.errorsBag) {
      return;
    }

    const data = {
      previousProviderCodeNumber,
      counterNumber,
      marketLocationIdentifier,
      customerSpecification,
      desiredDate,
      terminationDate,
      relocationDate,
      basicSupplyDate
    };

    const genericData = new FormData();
    genericData.append(
      'genericStorage[text]',
      this.$t('delivery.widget.authorize.to.terminate.text', {
        firstname: this.$store.state.journey_session.firstName,
        lastname: this.$store.state.journey_session.surname
      }).toString()
    );
    genericData.append('genericStorage[signatureDate]', this.signDate ?? '');
    genericData.append('genericStorage[signatureName]', this.signatureName ?? '');

    return ApiProvider.sessionUpdate(data)
      .then(() => {
        ApiProvider.updateGenericData(genericData);
        ApiProvider.validateDelivery()
          .then(() => {
            this.store.commit('SET_SESSION', data);
            trackingProvider.validationDeliverySuccessful(
              this.sessionState,
              this.$props.product,
              this.deliveryData.previousProvider,
              this.deliveryData.customerSpecification
            );
            this.$emit('deliverySubmit', this.deliveryData);
          })
          .catch((error) => {
            trackingProvider.validationDeliveryFailed();
            this.errorsBag = error.response.data.error.messages;
          });
      })
      .catch((error) => {
        if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
          localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
          window.location.href = document.referrer || window.location.origin;
        }
      });
  }

  protected setErrorsForRequired(): void {
    const specificationId = this.deliveryData.customerSpecification.id;
    if (specificationId === 'earliest_possible_date' || specificationId === 'desired_date') {
      this.setErrorsBag(
        'previousProviderCodeNumber',
        'rules.delivery.previousProvider.required',
        this.$t('rules.delivery.previousProvider.required').toLocaleString()
      );
    }
  }

  private setErrorsBag(errorKey: string, localeKey: string, message: string) {
    if (typeof this.errorsBag === 'undefined' || this.errorsBag === null) {
      this.errorsBag = {
        [errorKey]: [
          {
            key: localeKey,
            message
          }
        ]
      };
    } else {
      this.errorsBag[errorKey] = [
        {
          key: localeKey,
          message
        }
      ];
    }
  }
}
